import script from "./PlainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlainHeader.vue?vue&type=script&setup=true&lang=js"

import "./PlainHeader.vue?vue&type=style&index=0&id=2d6ab079&lang=css"

const __exports__ = script;

export default __exports__